import type { QuickSearchAction } from "../configuration/QuickSearchActions"
import { appendDateRangeSearchParams } from "./dateRangeSearchParams"

export const buildQuickSearchActionSearch = (action: QuickSearchAction, currentSearch: string): string => {
  const searchParams = new URLSearchParams(action.searchParams)

  appendDateRangeSearchParams(searchParams, currentSearch)

  searchParams.set("quickSearchAt", Date.now().toString())

  return `?${searchParams.toString()}`
}
